export default __webpack_public_path__ + "static/media/Ethos_Myyja.acf2f49a.svg";